import { useEffect, useState } from "react";
import clientPreferenceStatsRepository from "../../../repositories/ClientPreferenceStatsRepository";
import { 
  Heading, 
  ID_TO_TILES_FULL_DETAILS, 
  isSwitchableTile
  } from "@laxmimanogna/code-quick-components";
import {
  HStack,
  Text,
  Box,
  Grid,
  GridItem,
  Tooltip,
  Icon, 
  Spinner, 
  Button,
  Flex,
  Center
} from '@chakra-ui/react';
import { InfoOutlineIcon } from "@chakra-ui/icons";
import CQContainer from "../../../components/layout/CQContainer";
import AppColors from "../../../constants/AppColors";
import { FONT_FAMILY } from "../../../constants/Theme";
import { TagIcon } from "../../../constants/IconData";
import AuditSheetExport from "./AuditSheetExport";

const Statistics = () => {


  const [clickData, setClickData] = useState(null);
  //  Since Tab id 3 and 4 has 2 tabs we can switch between 0 and 1 for them
  const [tabSwitchData, setTabSwitchData] = useState({3: 0, 4: 0});

  const addTagData = (idCountList) => {
    // adding the Tag data
    idCountList[0].push(<TagIcon 
      msg={"Most Used"}
      colorScheme="green"
    /> )

    idCountList[idCountList.length - 1].push(<TagIcon 
      msg={"Least Used"}
      colorScheme="red"
    />)
  }
  const initializeClickHistoryData = async () => {
    try {
      const resp = await clientPreferenceStatsRepository.getTilesClickHistoryDataglobal();
      let idCountList = []
      resp.map((item, idx) => {
        idCountList.push([idx, item]);
      })

      idCountList.sort((a, b) => b[1] - a[1]);
      addTagData(idCountList)
      
      setClickData(idCountList);
    } catch(error) {
      // handle error
    } finally {
    }

    
  }
  useEffect(() => {
    initializeClickHistoryData();
  }, [])


    const renderTileHeader = (title, infoContent, id = null) => {
        return (
          <HStack justifyContent={'space-between'} align={'start'} marginTop={-2} marginBottom={2}>
            {title ? (
              <Text
                fontSize={'18px'}
                color={AppColors.primary}
                fontFamily={FONT_FAMILY.ptSans}
              >
                {title}
              </Text>
            ) : null}

            <HStack align={'start'}>
              {/* Switch Data for a tab */}
              {isSwitchableTile(id) && (
                        <Button 
                          onClick={() => setTabSwitchData(prev => (
                                    {...prev, 
                                      [id]: prev[id] ^ 1
                                    }
                                  ))}
                          height={7}
                          paddingX={6}
                        >
                          {`Switch`}
                        </Button>
                )
              }

              {/* The info tile component */}
              {infoContent ? (
                <Tooltip p={3} bg="whiteAlpha.900"
                  color="black"
                  borderRadius="md"
                  border="1px solid #43dde0" label={
                    <Box>
                      {infoContent}
                    </Box>
                  } placement="top-end">
                  <Box id={id || ''}> 
                    <Icon as={InfoOutlineIcon} w={4} h={4} cursor="pointer" _hover={{ color: AppColors.secondary, transition: 'color 0.3s ease-in-out' }} color={AppColors.primary} />
                  </Box>
                </Tooltip>
              ) : null}
            </HStack>
          </HStack>
        );
      };


    return (
          
          <CQContainer>
            <Box width={'100%'}>
              <Flex justifyContent="space-between" alignItems="baseline" mb={4}>
                <Heading
                  as="h3" fontSize="26px"
                  mb={8}
                  >{`Dashboard Tiles Click Data`}</Heading>
                <AuditSheetExport/>
              </Flex>
              <Grid
                  templateColumns={{
                  sm: 'repeat(1, 1fr)',
                  md: 'repeat(2, 1fr)',
                  lg: 'repeat(2, 1fr)',
                  xl: 'repeat(3, 1fr)',
                  '2xl': 'repeat(3, 1fr)',
                  }}
                gap={4}
                rowGap={4}
              >

                {clickData == null ? <Spinner> LOADING ....</Spinner> : (
                  clickData.map((item, idx) => (
                    <GridItem
                      borderRadius="md"
                      shadow={'md'}
                      bg={'white'}
                      width={'99%'}
                      cursor={'pointer'}
                      key={idx}
                      position="relative"
                    >
                      {/* Tag Data (Most and Least used) */}
                      <Box p={5} bg="white" borderRadius="md">
                        {item.length > 2 && (item[2])}
                      
                        {/* Tile header and description */}
                        {renderTileHeader(isSwitchableTile(item[0]) ? ID_TO_TILES_FULL_DETAILS[item[0]][0][tabSwitchData[item[0]]] : ID_TO_TILES_FULL_DETAILS[item[0]][0], 
                              isSwitchableTile(item[0]) ? ID_TO_TILES_FULL_DETAILS[item[0]][1][tabSwitchData[item[0]]] : ID_TO_TILES_FULL_DETAILS[item[0]][1], item[0]
                          )}
                        
                        {/* the count data */}
                        <Text style={{ fontSize: 19 }}> {`Count : `}
                          { <b>{`${item[1]}`}</b> }
                        </Text>                      
                      </Box>
                                
                    </GridItem>             
                  ))
                )}
              </Grid>

            </Box>

          </CQContainer>
          
    );
}

export default Statistics;